<template>
  <ul class="link-list" :class="{ unstyle : unstyle }">
    <li v-for="(link, i) in links" :key="i + link.url">
      <Link :link="link" />
    </li>
  </ul>
</template>
<script>
  import Link from './Link.vue'

  export default {
    name: 'LinkList',
    props: {
      links: Array,
      unstyle: Boolean,
    },
    components: {
      Link
    },
  }
</script>

<style lang="scss">
  .link-list {

    &.unstyle {
      padding: 0;
      margin: 0;

      li {
        list-style: none;
      }
    }
  }
</style>
